module.exports = __webpack_public_path__ + "static/media/2.ed3a5abb.svg";